import { React, useState, useEffect } from 'react';
import style from './../adminSect.module.scss';
import { CustomSearch } from './../../utils/Utils';
import Table from './Table';
import axios from './../../../config/apiConfig';
import locale from 'antd/es/date-picker/locale/es_ES';
import { DatePicker } from 'antd';
import moment from 'moment';

const VisitsTable = () => {
  const [page, setPage] = useState(1);
  const [givenPage, setGivenPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [status, setStatus] = useState(false);
  const [noVisitsFound, setNoVisitsFound] = useState(false);
  const [totalVisits, setTotalVisits] = useState(0);

  const [visits, setVisits] = useState([]);

  const [searchInput, setSearchInput] = useState({}); 
  // const [searchSelect, setSearchSelect] = useState({}); 
  const [dateFilter, setDateFilter] = useState(false); 

  const [filters, setFilters] = useState('');

  const { RangePicker } = DatePicker;

  const { sectHeader, usersTableHeader, headerTitle, headerHelpers, fullVH } =
    style;

  const getVisits = async (page) => {
    try {
      setVisits([]);
      setStatus(false);
      const { data } = await axios.get(`/visits?${filters ? filters : ''}${page ? `&${page}` : ''}`);
      setGivenPage(data.data[0].page);
      setTotalPages(data.data[0].totalPages);
      setVisits(data.data[0].visits);
      setStatus(data.status);
      setTotalVisits(data.data[0].count);
    } catch {
      setNoVisitsFound(true);
    }
  };

  useEffect(() => {
    if (givenPage !== page) {
      getVisits(`page=${page}`);
    }
  }, [page]);

  useEffect(() => {
    if (searchInput.inputSearch) {
      setPage(1);
      setGivenPage(1);
      setFilters(`${dateFilter ? `&dateSince=${dateFilter[0]}&dateTo=${dateFilter[1]}` : ''
      }`);
    // } else if (searchInput.inputSearch) {
    //   message.info('Por favor seleccione un tipo de filtro','0.5','14px');
    } else if (dateFilter) {
      setPage(1);
      setGivenPage(1);
      setFilters(`dateSince=${dateFilter[0]}&dateTo=${dateFilter[1]}`);
    } else if (searchInput.inputSearch === '') {
      setPage(1);
      setGivenPage(1);
      setFilters(false);
    }
  }, [searchInput, dateFilter]);

  useEffect(() => {
    getVisits();
  }, [filters]);

  const toggleModal = (set, state) => {
    set(!state);
  };

  function onChange(value) {
    if (value) {
      setDateFilter([
        value[0].format('YYYY-MM-DD'),
        value[1].format('YYYY-MM-DD'),
      ]);
      setPage(1);
    } else {
      setDateFilter(false);
    }
  }

  function disabledDate(current) {
    return current && current > moment().endOf('day');
  }

  // const opt = [
  //   {
  //     label: 'Visitador',
  //     value: 'provider',
  //   },
  //   {
  //     label: 'Stand',
  //     value: 'stand',
  //   },
  // ];

  return (
    <div className={fullVH}>
      <div className={`${sectHeader} ${usersTableHeader} visits_tableH`}>
        <div className={headerTitle}>
          <h1>
            <b>Visitas</b>
          </h1>
        </div>
        <div className={`${headerHelpers} visits_tableH_items`}>
          <CustomSearch
            placeholder="Buscar por visitador o por stand"
            setInput={setSearchInput}
            className="visits_tableH_search"
          />
          {/* <CustomSelect
            setInput={setSearchSelect}
            options={opt}
            placeholder="Filtros"
          /> */}
          <RangePicker
            disabledDate={disabledDate}
            format="DD-MM-YYYY"
            onChange={onChange}
            locale={locale}
          />
        </div>
      </div>

      <Table
        toggleModal={toggleModal}
        visits={visits}
        setPage={setPage}
        page={page}
        totalPages={totalPages}
        status={status}
        setNoVisitsFound={setNoVisitsFound}
        noVisitsFound={noVisitsFound}
        totalVisits={totalVisits}
      />
    </div>
  );
};

export default VisitsTable;
